import { Component, Inject, OnInit } from '@angular/core';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { SopoDialogRef, SOPO_DIALOG_DATA } from 'src/app/sopo-popup/interfaces/dialog';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-show-update',
    templateUrl: './show-update.component.html',
    styleUrls: ['./show-update.component.scss'],
    standalone: false
})
export class ShowUpdateComponent implements OnInit {
    isStaging = environment.staging;
    version = '';
    isForced = false;

    constructor(
        public sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) public data: {
            isForced: boolean,
            version: string,
        }
    ) {
        this.version = data.version;
        this.isForced = data.isForced;
    }


    ngOnInit() { }

    update() {
        AppUpdate.openAppStore();
    }

    close(choice: boolean) {
        this.sopoDialogRef.close(choice);
    }

}
